import React, { useEffect, useRef, useState } from "react";
import { ScrollView, View } from "react-native";
import { flatMap } from "lodash";
import { config } from "../config";
import RenderHtml from "react-native-render-html";
import sanitizeHtml from "sanitize-html";
import { useAnnouncements } from "../providers/PlaylistProvider";
import { useTheme } from "../providers/ThemeProvider";

const dupeCount = 20;

export const AnnouncementsScroller = () => {
  const theme = useTheme();
  const announcementBarHeight = theme.scaled(
    config.announcementsScroller.barHeight,
  );
  const announcements = useAnnouncements();
  const scrollView = useRef<ScrollView>(null);
  const scrollAnimation = useRef(0);
  const [contentWidth, setContentWidth] = useState<number>();

  useEffect(() => {
    if (contentWidth == null) return;

    const toValue = contentWidth / dupeCount;

    const interval = setInterval(() => {
      scrollAnimation.current += Math.max(theme.scaled(1), 1);
      if (scrollAnimation.current >= toValue) {
        scrollAnimation.current = 0;
      }

      scrollView.current?.scrollTo({
        x: scrollAnimation.current,
        animated: false,
      });
    }, 1000 / config.announcementsScroller.fps);

    return () => clearInterval(interval);
  }, [contentWidth, theme]);

  if (announcements.length === 0) {
    return null;
  }

  return (
    <View
      style={{
        backgroundColor: theme.announcementBar,
        height: announcementBarHeight,
      }}
    >
      <ScrollView
        horizontal
        ref={scrollView}
        showsHorizontalScrollIndicator={false}
      >
        <View
          style={{ flexDirection: "row", alignItems: "center" }}
          onLayout={({ nativeEvent: { layout } }) => {
            setContentWidth(layout.width);
          }}
        >
          {contentWidth != null &&
            (flatMap(Array(dupeCount).fill(announcements)) as string[]).map(
              (announcement, index) => (
                <RenderHtml
                  key={index}
                  contentWidth={contentWidth}
                  source={{
                    html: sanitizeHtml(announcement, {
                      allowedTags: ["b", "strong", "i", "em"],
                    }),
                  }}
                  baseStyle={{
                    paddingHorizontal: theme.spacing.medium,
                    color: theme.announcementBarText,
                    fontSize: theme.fontSize.body,
                  }}
                  tagsStyles={{
                    p: { margin: 0 },
                    br: { margin: 0 },
                  }}
                />
              ),
            )}
        </View>
      </ScrollView>
    </View>
  );
};
